import type { Catalog } from "../../en";
import { audiences } from "./audiences";
import { channels } from "./channels";
import { knowledge } from "./knowledge";
import { metaCallback } from "./meta-callback";
import { sourceDetail } from "./source-detail";
import { widgetStudio } from "./widget-studio";

/** Filipino: deploy + knowledge console screens (mirrors en/deploy-knowledge). */
export const deployKnowledge: Catalog["deployKnowledge"] = {
  planGate: {
    title: "Kailangan ng mas mataas na plano para sa {{feature}}",
    badge: "Feature ng plano",
    body: "Hindi kasama ito sa kasalukuyan mong plano. Mag-upgrade para magamit ito — nananatili ang iyong settings.",
    upgrade: "Ikumpara ang mga plano",
  },
  storageFull: {
    title: "Puno na ang inyong knowledge storage",
    body: "Hindi makakapagdagdag ng bagong file, pahina o teksto hangga't hindi nagbubura ng source, nagdaragdag ng storage o nag-a-upgrade. Patuloy na sasagot ang lahat ng naidagdag na.",
    add: "Magdagdag ng storage",
  },
  loadError: "Hindi ma-load ang page na ito.",
  loadErrorBody: "Tingnan ang iyong koneksyon at subukan muli. Walang nawala.",
  noPermission: "Wala kang pahintulot na baguhin ito",
  readOnly: "Read-only habang may support session",
  unsavedChanges: "May hindi pa nase-save",
  saving: "Sine-save…",
  knowledge,
  sourceDetail,
  widgetStudio,
  channels,
  audiences,
  metaCallback,
};
